import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ConfirmModalComponentProps } from '@bling-fe/shared/modals/confirm-modal';
import {
  CustomModalOptions,
  ModalAbstractComponent
} from '@bling-fe/shared/modals/base-modal';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

export interface EventDeletionModalResult {
  finishAction: boolean;
  reason_for_deletion?: string;
  cancellation_reason?: string;
}

export interface EventDeletionModalProps extends ConfirmModalComponentProps {
  isAdmin: boolean;
  isEventOwner: boolean;
}

@Component({
  selector: 'fl-event-deletion-modal',
  templateUrl: './event-deletion-modal.component.html',
  styleUrls: ['./event-deletion-modal.component.scss'],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: ModalAbstractComponent,
      useExisting: EventDeletionModalComponent
    }
  ]
})
export class EventDeletionModalComponent
  extends ModalAbstractComponent<
    EventDeletionModalProps,
    EventDeletionModalResult
  >
  implements OnInit
{
  form: FormGroup;
  private fb = new FormBuilder();

  ngOnInit() {
    // Build form based on user role
    const isReasonRequired = this.props?.isAdmin && !this.props?.isEventOwner;

    this.form = this.fb.group({
      reasonForDeletion: ['', isReasonRequired ? [Validators.required] : []],
      cancellationReason: [''] // Always optional
    });

    // Show validation immediately like other forms do
    this.form.markAllAsTouched();
  }

  public static override modalOptions: CustomModalOptions = {
    cssClass: 'auto-height bottom-sheet-modal'
  };

  get showReasonForDeletion(): boolean {
    return this.props?.isAdmin && !this.props?.isEventOwner;
  }

  get canConfirm(): boolean {
    return this.form?.valid ?? false;
  }

  onConfirm() {
    if (!this.canConfirm) return;

    const formValue = this.form.value;
    const result: EventDeletionModalResult = {
      finishAction: true,
      cancellation_reason: formValue.cancellationReason || ''
    };

    if (this.showReasonForDeletion && formValue.reasonForDeletion) {
      result.reason_for_deletion = formValue.reasonForDeletion;
    }

    this.dismiss(result);
  }

  onCancel() {
    this.dismiss({ finishAction: false });
  }
}
